import axios from 'axios';
// import { head } from 'node_modules/axios/index.d.cts';

// const API_BASE_URL = 'https://path.favapp.io/hoban/avnfr_gg';
const API_DEV_URL = 'https://apidev.broz.co.kr/hoban/avnfr_gg';

export const apiAWS = axios.create({
  baseURL: API_DEV_URL,
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

export const API_DEV_HOBAN = 'https://path.faview.ai/hoban/avnfr_gg/';

export const apiHoban = axios.create({
  baseURL: API_DEV_HOBAN,
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});
export const spaceAPI = {
  getAllSpace: (header: object) =>
    apiAWS.get('/space/get-space', { headers: header }),
};
